import { useSnackbarContext } from 'Context/SnackbarContext';

const useMessageInput = (
  draftMessageResource,
  sendMessage,
  refreshMessages,
  autoSaveDraft,
) => {
  const { displayErrorMessage } = useSnackbarContext();

  const handleContentChange = async (value) => {
    draftMessageResource.attr('content', value);
    await autoSaveDraft(draftMessageResource);
  };

  const handleSubjectChange = async (value) => {
    draftMessageResource.attr('subject', value);
    autoSaveDraft(draftMessageResource);
  };

  const handleTemplateInsert = async (value) => {
    draftMessageResource.attr('templateID', value);
    await autoSaveDraft(draftMessageResource);
  };

  const handleSubmit = async (value, args = {}) => {
    try {
      await sendMessage(value, args);
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }
  };

  const handleAttachmentDelete = async (attachmentResource) => {
    try {
      await attachmentResource.delete();
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }

    await refreshMessages();
  };

  return {
    handleSubmit,
    handleContentChange,
    handleSubjectChange,
    handleAttachmentDelete,
    handleTemplateInsert,
  };
};

export { useMessageInput };
